export function dateCellCSSClass(date: Date) {
    return [0, 6].includes(date.getDay()) ? 'bg-yellow-lighten-4' : ''
}
